import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const ChatRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 14px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};
`;

export const ChatTitle = styled.span`
    font-size: 0.9375rem;
    color: ${colors.textPrimary};
    word-break: break-word;
`;

export const ChatMeta = styled.span`
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;

// Отрицательный отступ гасит паддинг последней текстовой кнопки — подпись
// остаётся оптически выровненной по краю карточки.
export const RowActions = styled.div`
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 8px;
    margin-right: -8px;
`;

export const AddButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const EmptyText = styled.p`
    margin: 0;
    font-size: 13px;
    color: ${colors.textSecondary};
`;

export const Instruction = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px 14px;
    border-radius: ${radii.base};
    background: ${colors.contentBg};
`;

export const InstructionStep = styled.p`
    margin: 0;
    font-size: 13px;
    color: ${colors.textSecondary};

    a {
        color: ${colors.primary};
    }
`;

// Оба мессенджера требуют скопировать id вместе со знаком «-» — без него уведомления
// молча не доходят, поэтому предупреждение выделено.
export const InstructionWarning = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    color: ${colors.danger};
`;
